/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { AgingReportPeriod } from '@core/enums';

export class AgingReportSearch {
  constructor(
    public text = '',
    public interval: 'Month' | 'Year To Date' = 'Year To Date',
    public testAccount = false,
    public pageSize = 25,
    public pageIndex = 0,
    public billingPeriod: string[] = [],
    public invoicesPeriod?: AgingReportPeriod
  ) {}
}
